<template>
  <section class="container">
    <Heading :level="3" class="title">Meus produtos</Heading>
    <Grid :columns="[6, 6]" :gutter="24">
      <CategoryCard
        v-for="(card, key) in cards"
        :key="key"
        :icon="card.icon"
        :color="card.color?.hexa"
        :secondary-view-disabled="!card.details"
        :loading="loading"
        class="card"
        data-testid="category-card"
        @on-click="handleRedirect(card)"
      >
        <template #main>
          <CategoryCardMain :card="card" />
        </template>
        <template #footer>
          <CategoryCardFooter :card="card" />
        </template>
        <template #secondary-main>
          <CategoryCardProfitabilityMain :details="card.details" />
        </template>
        <template #secondary-footer>
          <CategoryCardProfitabilityFooter :details="card.details?.data" />
        </template>
      </CategoryCard>
    </Grid>
  </section>
</template>
<script setup lang="ts">
import { Heading, Grid, CategoryCard } from '@warrenbrasil/nebraska-web';
import {
  CategoryCardMain,
  CategoryCardFooter,
  CategoryCardProfitabilityMain,
  CategoryCardProfitabilityFooter
} from './components';
import { useRoute, useRouter } from 'vue-router/composables';
import { EProductType, IProduct } from '@/modules/products/services/products';

interface Props {
  loading: boolean;
  cards: IProduct[];
}

defineProps<Props>();
const router = useRouter();
const route = useRoute();

function goToCatalog(tab: EProductType) {
  if (tab === EProductType.Pension) {
    window.open('https://lp.warren.com.br/previdencia');
    return;
  }

  router.push({
    name: 'productsCatalog',
    params: {
      type: tab || 'fixed-income'
    }
  });
}

function goToCategory(productType: EProductType) {
  window.location.assign(`/products/#/categories/${productType}`);
}

function goToPortfolioCatalog() {
  const currentModule = route.name;

  router.push({ name: 'catalog', query: { module: currentModule } });
}

function handleRedirect({ action, productType }: IProduct) {
  const redirectMapper: { [key: string]: () => void } = {
    OPEN_CATALOG: () => goToCatalog(productType),
    OPEN_DETAILS: () => goToCategory(productType),
    OPEN_PORTFOLIO_CATALOG: () => goToPortfolioCatalog()
  };

  redirectMapper[action]();
}
</script>
<style lang="less" scoped>
.title {
  margin-bottom: @size-spacing-x600;
}
.card {
  margin-bottom: 24px;
}
</style>
